import { z } from 'zod';

export const earlyAssessmentFilterValidator = z.object({
  status: z.array(z.string()).default([])
});
